import { render, staticRenderFns } from "./BarNutritionDetails.vue?vue&type=template&id=46e0980c"
import script from "./BarNutritionDetails.vue?vue&type=script&lang=js"
export * from "./BarNutritionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports